import React, { useState } from "react";
import DoctorInfoService from "../doctorInfo/doctorInfoService";
import TooltipInput from "../ToolTip/TooltipInput";
import TooltipTextArea from "../ToolTip/TooltipTextArea";
import "../shared/PageWrapper.css";

const RegisterDoctor = () => {
  const [form, setForm] = useState({
    officeId: "",
    firstName: "",
    lastName: "",
    username: "",
    password: "",
    bio: "",
    specialty: "",
    doctorPicture: "",
    rating: 100,
    role: "DOCTOR", // Default role
  });

  const handleChange = (key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const registerRequest = {
      username: form.username.trim(),
      password: form.password.trim(),
      officeId: parseInt(form.officeId, 10),
    };
    const doctorDetails = {
      officeId: parseInt(form.officeId, 10),
      firstName: form.firstName.trim(),
      lastName: form.lastName.trim(),
      bio: form.bio.trim(),
      specialty: form.specialty.trim(),
      doctorPicture: "",
      rating: 100,
    };

    try {
      // ✅ Step 1: Register credentials WITHOUT affecting current admin session
      const registerRes = await fetch(`/api/auth/register`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          username: registerRequest.username,
          password: registerRequest.password,
          role: form.role,
        }),
      });
      if (!registerRes.ok) {
        const errorData = await registerRes.json();
        throw new Error(errorData.error || "Auth registration failed.");
      }
      alert("✅ Doctor Auth Credentials Registered");

      // ✅ Step 2: Create doctor entity
      const registerEntityResult = await new DoctorInfoService().registerDoctor(registerRequest);
      alert("✅ Doctor Entity Created");

      // ✅ Step 3: Update full doctor details
      const result = await new DoctorInfoService().updateDoctorDetails(
        null,
        registerRequest.username,
        doctorDetails
      );
      alert("✅ Doctor Info Updated: " + JSON.stringify(result));
    } catch (error) {
      alert("❌ Error: " + error.message);
    }
  };

  return (
    <div className="pageWrapper">
      <div className="formContainer">
        <form onSubmit={handleSubmit}>
          <TooltipInput
            type="number"
            id="officeId"
            placeholder="Enter Office ID"
            tooltip="Office identification number."
            value={form.officeId}
            onChange={(v) => handleChange("officeId", v)}
          />
          <TooltipInput
            type="text"
            id="firstName"
            placeholder="Enter First Name"
            tooltip="Your first name."
            value={form.firstName}
            onChange={(v) => handleChange("firstName", v)}
          />
          <TooltipInput
            type="text"
            id="lastName"
            placeholder="Enter Last Name"
            tooltip="Your last name."
            value={form.lastName}
            onChange={(v) => handleChange("lastName", v)}
          />
          <TooltipInput
            type="text"
            id="username"
            placeholder="Enter Username"
            tooltip="Your unique username."
            value={form.username}
            onChange={(v) => handleChange("username", v)}
          />
          <TooltipInput
            type="password"
            id="password"
            placeholder="Enter Password"
            tooltip="Use at least 8 characters."
            value={form.password}
            onChange={(v) => handleChange("password", v)}
          />
          <TooltipTextArea
            id="bio"
            placeholder="Enter Bio"
            tooltip="Brief description about yourself."
            value={form.bio}
            onChange={(v) => handleChange("bio", v)}
          />
          <TooltipInput
            type="text"
            id="specialty"
            placeholder="Enter Specialty"
            tooltip="Your medical specialty."
            value={form.specialty}
            onChange={(v) => handleChange("specialty", v)}
          />
          <label htmlFor="role">Role</label>
          <select
            id="role"
            value={form.role}
            onChange={(e) => handleChange("role", e.target.value)}
          >
            <option value="FRONT-DESK">FRONT-DESK</option>
            <option value="DOCTOR">DOCTOR</option>
            <option value="MANAGER">MANAGER</option>
          </select>

          <input type="hidden" id="doctorPicture" value={form.doctorPicture} />
          <input type="hidden" id="rating" value={form.rating} />

          <button type="submit">Register</button>
        </form>
      </div>
    </div>
  );
};

export default RegisterDoctor;
